import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import {PageNotFoundComponent} from './pages/page-not-found/page-not-found.component';
import {VersionComponent} from './pages/version/version.component';

const routes: Routes = [
  {
    path: 'zuege',
    loadChildren: () =>
      import('./pages/trains-lines/trains-lines.module').then(m => m.TrainsLinesModule)
  },
  {
    path: 'trains',
    loadChildren: () =>
      import('./pages/trains-lines/trains-lines.module').then(m => m.TrainsLinesModule)
  },
  {
    path: 'treni',
    loadChildren: () =>
      import('./pages/trains-lines/trains-lines.module').then(m => m.TrainsLinesModule)
  },
   {
    path: 'rss-bvi',
    loadChildren: () => import('./pages/rss/rss.module').then(m => m.RssModule)
  },
  {
    path: 'rss-itf',
    loadChildren: () => import('./pages/rss/rss.module').then(m => m.RssModule)
  },
  {
    path: 'rss-rti',
    loadChildren: () => import('./pages/rss/rss.module').then(m => m.RssModule)
  },
  {
    path: 'departure-arrival',
    loadChildren: () => import('./pages/dep-arr-internal/dep-arr-internal.module').then(m => m.DepArrInternalModule)
  },
  {
    path: 'ab-an',
    loadChildren: () => import('./pages/dep-arr-internal/dep-arr-internal.module').then(m => m.DepArrInternalModule)
  },
  {
    path: 'dep-arr',
    loadChildren: () => import('./pages/dep-arr-internal/dep-arr-internal.module').then(m => m.DepArrInternalModule)
  },
  {
    path: 'part-arr',
    loadChildren: () => import('./pages/dep-arr-internal/dep-arr-internal.module').then(m => m.DepArrInternalModule)
  },
  {
    path: 'eco',
    loadChildren: () => import('./pages/eco/eco.module').then(m => m.EcoModule)
  },
  {
    path: 'version', component: VersionComponent
  },
  { path: '404', component: PageNotFoundComponent },
  { path: '**', component: PageNotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: []
})
export class AppRoutingModule {}
